/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from "react"
import { TypographyProps as MUITypographyProps } from "@mui/material"
import { rem, Text, TextProps } from "@mantine/core"
import cx from "classnames"
import withMappedProps from "hoc-lib/propsMapping"
import mapNumberPropResponsive from "utils-lib/mappingUtils"
import styles from "./Typography.mantine.module.scss"

export const MantineTypography = (props: TextProps) => <Text {...props} />

export const muiToMantine = (
  props: MUITypographyProps,
): TextProps & { component: string } => {
  const variant = props.variant || "body1"
  const anyProps = { ...(props as any) }
  delete anyProps.color

  const componentString = ["h1", "h2", "h3", "h4", "h5", "h6", "span"].includes(
    variant,
  )
    ? anyProps.component ?? variant
    : anyProps.component ?? "span"
  const colorString = props.color
    ? (styles as Record<string, string>)[`mui-color-${props?.color}`]
    : undefined

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return {
    ...anyProps,
    p: mapNumberPropResponsive(anyProps.p ?? anyProps.padding, (n) =>
      rem(n * 8),
    ),
    pt: mapNumberPropResponsive(anyProps.pt ?? anyProps.paddingTop, (n) =>
      rem(n * 8),
    ),
    pr: mapNumberPropResponsive(anyProps.pr ?? anyProps.paddingRight, (n) =>
      rem(n * 8),
    ),
    pb: mapNumberPropResponsive(anyProps.pb ?? anyProps.paddingBottom, (n) =>
      rem(n * 8),
    ),
    pl: mapNumberPropResponsive(anyProps.pl ?? anyProps.paddingLeft, (n) =>
      rem(n * 8),
    ),
    px: mapNumberPropResponsive(anyProps.px ?? anyProps.paddingX, (n) =>
      rem(n * 8),
    ),
    py: mapNumberPropResponsive(anyProps.py ?? anyProps.paddingY, (n) =>
      rem(n * 8),
    ),
    m: mapNumberPropResponsive(anyProps.m ?? anyProps.margin, (n) =>
      rem(n * 8),
    ),
    mt: mapNumberPropResponsive(anyProps.mt ?? anyProps.marginTop, (n) =>
      rem(n * 8),
    ),
    mr: mapNumberPropResponsive(anyProps.mr ?? anyProps.marginRight, (n) =>
      rem(n * 8),
    ),
    mb: mapNumberPropResponsive(anyProps.mb ?? anyProps.marginBottom, (n) =>
      rem(n * 8),
    ),
    ml: mapNumberPropResponsive(anyProps.ml ?? anyProps.marginLeft, (n) =>
      rem(n * 8),
    ),
    mx: mapNumberPropResponsive(anyProps.mx ?? anyProps.marginX, (n) =>
      rem(n * 8),
    ),
    my: mapNumberPropResponsive(anyProps.my ?? anyProps.marginY, (n) =>
      rem(n * 8),
    ),
    ta: anyProps.textAlign ?? anyProps.align,
    lh: mapNumberPropResponsive(anyProps.lineHeight, (n) => rem(n * 4)),
    top: mapNumberPropResponsive(anyProps.top, (n) => rem(n * 8)),
    left: mapNumberPropResponsive(anyProps.left, (n) => rem(n * 8)),
    bottom: mapNumberPropResponsive(anyProps.bottom, (n) => rem(n * 8)),
    right: mapNumberPropResponsive(anyProps.right, (n) => rem(n * 8)),
    pos: anyProps.position,
    w: mapNumberPropResponsive(anyProps.w ?? anyProps.width, (n) => rem(n * 8)),
    h: mapNumberPropResponsive(anyProps.h ?? anyProps.height, (n) =>
      rem(n * 8),
    ),
    className: cx(
      {
        [styles[variant] ?? ""]: variant,
        [styles.noWrap]: anyProps.noWrap,
        [styles.gutterBottom]: anyProps.gutterBottom,
      },
      colorString,
      props.className,
    ),
    style: {
      justifyContent: anyProps.justifyContent,
      alignItems: anyProps.alignItems,
      alignContent: anyProps.alignContent,
      gap: anyProps.gap,
      whiteSpace: anyProps.whiteSpace,
      flexGrow: anyProps.flexGrow,
      flexShrink: anyProps.flexShrink,
      flexDirection: anyProps.flexDirection,
      flexWrap: anyProps.flexWrap,
      overflow: anyProps.overflow,
      ...anyProps.sx,
      ...anyProps.style,
    },
    component: componentString,
  }
}
// TODO: test color="secondary | primary"

export const MUIMappedTypography = withMappedProps(
  MantineTypography,
  muiToMantine,
)

export default MantineTypography
